import { signal } from "@preact/signals";

/** A bare `#ABCD` deep link (spec §3) prefills the join code; everything else is a
 * normal `/`-separated hash path. */
function normalizeHash(hash: string): string {
  const raw = hash.replace(/^#/, "");
  if (/^[A-Za-z0-9]{4}$/.test(raw)) return `/join/${raw.toUpperCase()}`;
  return raw || "/";
}

export const currentPath = signal(normalizeHash(location.hash));

window.addEventListener("hashchange", () => {
  currentPath.value = normalizeHash(location.hash);
});

export function navigate(path: string) {
  location.hash = path;
  currentPath.value = normalizeHash(location.hash);
}

export function pathSegments(path: string): string[] {
  return path.split("/").filter(Boolean);
}
